import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bootstrapCart } from "./actions/cart";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Store from "./pages/Store";
import Contact from "./pages/Contact";
import ThreeDPrint from "./pages/ThreeDPrint";
import LaserCutting from "./pages/LaserCutting";
import QuoteReview from "./pages/QuoteReview";
import PlasmaCutting from "./pages/PlasmaCutting";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Privacy from "./pages/Privacy";
import './index.css';

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(bootstrapCart());
  }, [dispatch]);

  function NoMatch() {
    return (
      <div>
        <h2>Nothing to see here!</h2>
        <p>
          <Link to="/">Go to the home page</Link>
        </p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="store" element={<Store />} />
          <Route path="cart" element={<Cart />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="3dprint" element={<ThreeDPrint />} />
          <Route path="laser-cutting" element={<LaserCutting />} />
          <Route path="plasma-cutting" element={<PlasmaCutting />} />
          <Route path="cutting-quote/:reviewToken/review" element={<QuoteReview />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
